import api from "./api";

export function getForexOrder(page = 1, limit = 10, search = "") {
  return api.get(`/forexorder?page=${page}&limit=${limit}&search=${search}`);
}

export function getForexOrderById(id) {
  return api.get(`/forexorder/${id}`);
}

export function updateForexOrderStatus(id, status) {
  return api.put(`/forexorder/${id}/status`, { status });
}
